import { render } from "./companypass.vue?vue&type=template&id=439b2ba6&scoped=true"
import script from "./companypass.vue?vue&type=script&lang=js"
export * from "./companypass.vue?vue&type=script&lang=js"

import "./companypass.vue?vue&type=style&index=0&id=439b2ba6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-439b2ba6"

export default script